import React from 'react';
import { theme } from '../styles/theme';
import Container from '../components/ui/Container';
import FooterPageContent from '../components/layout/FooterPageContent';

const ProductDisclaimerPage = () => {
  const pageStyles = {
    padding: `${theme.spacing.xxl} 0`,
    backgroundColor: theme.colors.background,
    minHeight: '100vh',
  };

  const contentStyles = {
    maxWidth: '900px',
    margin: '0 auto',
    padding: `0 ${theme.spacing.lg}`,
  };

  const headingStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xxl,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.primary,
    marginBottom: theme.spacing.lg,
    textAlign: 'center',
  };

  const subHeadingStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xl,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.primaryDark,
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.md,
  };

  const paragraphStyles = {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.relaxed,
    color: theme.colors.text,
    marginBottom: theme.spacing.md,
  };

  const listStyles = {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.relaxed,
    color: theme.colors.text,
    marginBottom: theme.spacing.md,
    paddingLeft: theme.spacing.xl,
  };

  const nestedListStyles = {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.relaxed,
    color: theme.colors.text,
    marginBottom: theme.spacing.md,
    paddingLeft: theme.spacing.xl,
    listStyleType: 'circle',
  };

  return (
    <FooterPageContent slug="product-disclaimer">
    <div style={pageStyles}>
      <Container>
        <div style={contentStyles}>
          <h1 style={headingStyles}>Product Disclaimer</h1>

          <h2 style={subHeadingStyles}>Fur Products (Fox, Nutria, Vizcacha, Rabbit)</h2>
          <ul style={listStyles}>
            <li>
              AB-44 Fur products prohibition law, fur products are not prohibited for resale in
              the state of California, we will not be able to ship these products to the state of
              California.
            </li>
          </ul>

          <h2 style={subHeadingStyles}>Dyed Wool Products (Tibetan, Icelandic, New Zealand Sheep)</h2>
          <ul style={listStyles}>
            <li>
              Dyed and natural wool should not be placed in direct or indirect sunlight (includes
              near windows treated with UV protection) as the hair may fade, become brittle, or
              break. We are not responsible for these types of damage.
            </li>
            <li>
              Our vendors do their best to maintain dye lots, but they are subject to some
              variation among each shipment as the wool is dyed and each skin does take the
              color differently.
            </li>
          </ul>

          <h2 style={subHeadingStyles}>Cowhide Rugs</h2>
          <ul style={listStyles}>
            <li>
              Photos listed are generic photos (not the exact cowhide you will receive) unless
              hides are listed under pick your exact cowhide and have an individualized sku.
            </li>
            <li>
              Cowhides are natural and may contain the following brands and old scars such
              as barb wire markings, these are not considered defects as they are natural to
              the animal and considered a sign of authenticity.
            </li>
            <li>
              Small patches or stitches may be on cowhides; these are performed by the
              tanneries in Brazil &amp; Colombia as small repairs to fix imperfections in the hide
              after the tanning process and are not considered to be defects or damaged.
              <ul style={nestedListStyles}>
                <li>
                  Cowhides listed under our B grade section may have large very visible
                  patches, stitches, slippage or missing hair, or paint repairs on them and
                  these are sold at a discounted rate.
                </li>
              </ul>
            </li>
          </ul>

          <h2 style={subHeadingStyles}>Taxidermy</h2>
          <ul style={listStyles}>
            <li>
              Taxidermy should be treated for moths, we recommend treating all mounts large
              or small 1-3 times per year to prevent any moth damage. We are not responsible
              for moth damage.
            </li>
          </ul>

          <h2 style={subHeadingStyles}>Cowhide Care Instructions</h2>
          <ul style={listStyles}>
            <li>
              <strong>Dirt and Dust:</strong> You can vacuum your cowhide rug just like other rugs and
              carpets in your house. The rug should always be vacuumed in the direction of the
              hairs and with the beater bar raised. In addition to vacuuming, it is important to
              occasionally take the cowhide rug outside to shake it. This gets out any deep
              dust and dirt that the vacuum may have missed.
            </li>
            <li>
              <strong>Stains or Spills:</strong> Cowhide rugs are very durable and typically do not stain. If a
              stain does get on the cowhide rug, start by putting water on a paper towel and
              blot out the stain. If that doesn't work, use mild soap, or gentle shampoo to help
              remove the stain. If there are grease stains, use eucalyptus oil mixed with water
              to blot out the stain.
            </li>
            <li>
              <strong>Curling Edges:</strong> Cowhide rugs tend to curl on the edges. If this occurs spray
              warm water on the top and bottom of the rug where the curl is. Then, place a
              paper towel on the top and bottom of the curled edge. Next, put a pile of heavy
              books on top of the edge. After a few hours, the rug should flatten out. After you
              complete this process, let the rug air dry.
            </li>
          </ul>
        </div>
      </Container>
    </div>
    </FooterPageContent>
  );
};

export default ProductDisclaimerPage;
